import React from "react";

function About() {
  return (
    <>
      <section id="tips" className="section">
        <h2>सट्टा मटका टिप्स</h2>
        <ul>
          <li>खेल की सही जानकारी लें और नियमों को समझें।</li>
          <li>पुराने रिजल्ट्स का विश्लेषण करें और रणनीति बनाएं।</li>
          <li>बजट तय करें और कभी भी उससे ज्यादा न लगाएं।</li>
          <li>भावनाओं में आकर ज्यादा न खेलें।</li>
          <li>जोखिम को कम करने के लिए छोटे गेम्स से शुरुआत करें।</li>
          <li>ट्रेंड्स पर ध्यान दें लेकिन पूरी तरह उन पर निर्भर न रहें।</li>
          <li>हमेशा स्मार्ट और सोच-समझकर दांव लगाएं।</li>
        </ul>
      </section>
      <section id="about" className="section">
        <h2>हमारे बारे में</h2>
        <p>
          मधु श्री सट्टा मटका एक प्रतिष्ठित और विश्वसनीय मंच है जहाँ आपको
          रोज़ाना के मटका रिजल्ट्स, गाइडेंस और टिप्स एक ही स्थान पर मिलते हैं।
          हमारा उद्देश्य उपयोगकर्ताओं को सही जानकारी प्रदान करना और एक सुरक्षित
          एवं मनोरंजक अनुभव देना है।
        </p>
        <p>
          हम पारंपरिक सट्टा के साथ-साथ नए खिलाड़ियों को प्रशिक्षित करने और उनकी
          मदद करने के लिए हर संभव प्रयास करते हैं। हमारा समुदाय हर दिन लाखों
          उपयोगकर्ताओं को सटीक जानकारी और अपडेट प्रदान करता है।
        </p>
      </section>
      <div className="layout">
        <div className="row">
          <div className="col-md-12">
            <section className="section text-center text-white">
              <h3 className="result">Introduction to Madhu Shree</h3>
              <p>
                Welcome to Madhu Shree, where entertainment takes center stage,
                and a world of diverse activities awaits you. In our vibrant
                community, we've crafted an experience beyond conventional
                platforms, offering a rich tapestry of entertainment for users
                with varied interests.
                <br />
                <br />
                Discover the joy of connecting with like-minded individuals
                through our socializing features. Whether you're an extrovert
                seeking lively conversations or an introvert looking for a cozy
                virtual space, Madhu Shree is your go-to destination for
                meaningful connections.
                <br />
                <br />
                Madhushree.in is your ultimate destination for everything
                related to the fascinating world of the Satta Matka. As the
                leading authority in the realm of Matka Games, we provide
                accurate results and expert guidance. Whether you're a seasoned
                player or a newcomer, our comprehensive resources like Madhu
                Shree Matka, Matka Result, charts, and games offer a thrilling
                and immersive experience.
              </p>
            </section>

            <section className="section text-center">
              <label className="d-block mb-3">HISTORY OF SATTA MATKA</label>
              <p>
                The history of Satta Matka dates to the 1960s in India. It began
                with betting on cotton rates in the Bombay Cotton Exchange. As
                the game evolved, it shifted to a number-based system involving
                draws from a "matka" (earthen pot). Over time, various markets
                like Main Madhu Shree Matka emerged, each with its own rules and
                draws, offering players diverse opportunities.
              </p>
            </section>

            <section className="section text-center">
              <label className="d-block mb-3">TYPES OF SATTA MATKA</label>
              <p>
                Madhu Shree Matka includes several variants based on betting
                styles, timings, and markets <br />
                - Daytime and nighttime versions
                <br />
                - Based on cotton rate openings and closings
                <br />
                - Region-specific formats
                <br />
                - Main Madhu Shree Market with unique draws and rules
                <br />
                These variations offer distinct experiences and winning
                possibilities.
              </p>
            </section>

            <section className="section text-center">
              <label className="d-block mb-3">THE BASICS OF MATKA</label>
              <p>
                Matka originated in the 1960s and involves betting on numbers.
                “Satta” means betting, and “Matka” means earthen pot. The game
                is based on random number draws.
                <br />
                <strong>Game Format </strong> Usually played on
                holidays/weekends. Players bet on numbers 0–9.
                <br />
                <strong>Betting Process </strong> Includes singles, pairs
                (Jodi), three-digit combos (Patti), etc.
                <br />
                <strong>Draw </strong> Numbers drawn twice form results like 53
                and 46.
                <br />
                <strong>Result </strong> Final results are derived using
                combinations and often last digit.
                <br />
                <strong>Payout </strong> Varies based on bet type and market.
              </p>
            </section>

            <section className="section text-center">
              <label className="d-block mb-3">
                DIFFERENT VARIANTS OF MATKA GAMES
              </label>
              <p>
                - <strong>Single </strong> Bet on a single digit (0–9).
                <br />- <strong>Jodi </strong> Bet on two-digit combinations
                (00–99).
                <br />- <strong>Patti </strong> Three-digit combinations
                (single, double, triple).
                <br />- <strong>Half Sangam </strong> One digit + one pair.
                <br />- <strong>Full Sangam </strong> Full combination of both
                sets.
                <br />- <strong>Cycle Patti </strong> Three-digit combos in a
                specific order.
              </p>
            </section>
            <section className="section text-center">
              <label className="d-block mb-3">
                WHAT IS MADHU SHREE MATKA AND ITS WINNING STRATEGY
              </label>
              <p>
                Madhu Shree Matka focuses on number predictions tied to cotton
                market rates. Here are key tips <br />
                1. Learn game rules and bet types.
                <br />
                2. Review past results, but remember it's chance-based.
                <br />
                3. Stick to your budget.
                <br />
                4. Spread your bets to manage risk.
                <br />
                5. Avoid chasing losses.
                <br />
                6. Make calm, rational choices.
                <br />
                7. Stay informed with market updates.
              </p>
            </section>
            <div className="booking-alert">
              <p>
                📢 <strong>बुकिंग चालू!</strong> 💥 सिर्फ आज – 1 जोड़ी 2 पत्ती
                फिक्स 🎯
              </p>
              <p>
                <strong>₹2500/-</strong> में लाखों कमाने का मौका – मनी बैक
                गारंटी!
              </p>
            </div>
          </div>
        </div>
      </div>
      <section className="full-bhaav-section">
        <h3>FULL BHAAV</h3>
        <div className="bhaav-container">
          <div className="bhaav-item">
            <img src="./Group 1171276042.png" alt="Single Pana" />
            <p>SINGLE PANA 150</p>
          </div>
          <div className="bhaav-item">
            <img src="./Group 1171276042.png" alt="Double Pana" />
            <p>DOUBLE PANA 300</p>
          </div>
          <div className="bhaav-item">
            <img src="./Group 1171276042.png" alt="Triple Pana" />
            <p>TRIPLE PANA 1000</p>
          </div>
          <div className="bhaav-item">
            <img src="./Group 1171276042.png" alt="Akhar" />
            <p>AKHAR 10</p>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
